import { NgModule } from '@angular/core';
import { CalendarModule } from '@app/pcs/shared/components/calendar/calendar.module';
import { SharedModule } from '@app/shared/shared.module';
import { CalendarSmallComponent } from '@dossier/shared/components/calendar-small/calendar-small.component';
import { CalendarSmallTooltipComponent } from '@dossier/shared/components/calendar-small/calendar-small-tooltip.component';
import { RunningDaysWatermarkModule } from '@dossier/shared/components/running-days-watermark/running-days-watermark.module';
import { DossierPipesModule } from '@dossier/shared/pipes/dossier-pipes.module';

@NgModule({
  imports: [
    SharedModule,
    CalendarModule,
    RunningDaysWatermarkModule,
    DossierPipesModule
  ],
  declarations: [
    CalendarSmallComponent,
    CalendarSmallTooltipComponent
  ],
  exports: [
    CalendarSmallComponent,
    CalendarSmallTooltipComponent
  ]
})
export class CalendarSmallModule {

}
